import RenderHeader from '@components/DataGrid/RenderHeader';
import { applyColumnQuickFilter, caseInsensitiveIncludes } from '../columns';
import RenderCell from '@components/DataGrid/RenderCell';
import { defaultSortComparator } from '@components/DataGrid/types';
import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import { GridColDefExtended } from '@mui/x-data-grid-pro';

import styles from '../../RenderCell.module.css';

const traceContainerHoldsDefinition: GridColDefExtended<DispatchLeg> = {
	field: 'Trc Holds',
	minWidth: 130,
	width: 150,
	headerName: 'Trc Holds',
	renderHeader: () => <RenderHeader primaryText='Trc Holds' />,
	renderCell: ({ row }) => (
		<RenderCell
			primarySlot={
				row.trcCntrHolds && (
					<span
						className={styles.bold}
						title={row.trcCntrHolds}
					>
						{row.trcCntrHolds}
					</span>
				)
			}
		/>
	),
	disableReorder: true,
	getApplyQuickFilterFn: (value: string) => {
		return (_, row): boolean =>
			applyColumnQuickFilter(value, row, (value: string, row: DispatchLeg) => {
				const { trcCntrHolds } = row;
				return caseInsensitiveIncludes(value, [trcCntrHolds]);
			});
	},
	valueGetter: (_, row: DispatchLeg) => row.trcCntrHolds ?? '',
	sortable: true,
	sortComparator: defaultSortComparator
};

export default traceContainerHoldsDefinition;
